import { render } from "./dialogHg.vue?vue&type=template&id=1f08a735&scoped=true"
import script from "./dialogHg.vue?vue&type=script&lang=js"
export * from "./dialogHg.vue?vue&type=script&lang=js"

import "./dialogHg.vue?vue&type=style&index=0&id=1f08a735&scoped=true&lang=scss"

import exportComponent from "D:\\project\\admin-system3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f08a735"]])

export default __exports__